import React, { useState, useRef, useEffect } from "react";
import { FiX } from "react-icons/fi";
import { motion } from "framer-motion";
import bot from "../../assets/chat-bot.png";

const ChatWidget = ({ isOpen, toggleChat }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false); 
   const endOfMessagesRef = useRef(null);

  // const sendMessage = () => {
  //   if (!input.trim()) return;

  //   setMessages((prev) => [...prev, { sender: "user", text: input }]);

  //   setTimeout(() => {
  //     setMessages((prev) => [
  //       ...prev,
  //       {
  //         sender: "bot",
  //         text:
  //           "🤖 Beep boop... I'm still under construction. Come back soon to meet the future me!",
  //       },
  //     ]);
  //   }, 800);

  //   setInput("");
  // };
  const sendMessage = async () => {
  if (!input.trim()) return;

  // Add user message
  setMessages((prev) => [...prev, { sender: "user", text: input }]);

  const userMessage = input;
  setInput("");
  setIsTyping(true);

  try {
    // const res = await fetch("https://dev.bibhup.co.in/webhook/personal-ai", {
      const res = await fetch("https://dev.bibhup.co.in/webhook/personal-ai", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message: userMessage }),
    });
    // console.log("promise - " + res.json())
    const data = await res.json();
    console.log("response  - " + data)
    const replyText = data[0]?.output || "⚠️ No response from AI.";
    console.log("reply- " + replyText);
    // setMessages((prev) => [
    //   ...prev,
    //   { sender: "bot", text: replyText },
    // ]);
     setTimeout(() => {
        setMessages((prev) => [...prev, { sender: "bot", text: replyText }]);
        setIsTyping(false); // 👈 Hide typing animation
      }, 600);
  } catch (err) {
    console.error("Error talking to n8n:", err);
    setMessages((prev) => [
      ...prev,
      { sender: "bot", text: "❌ Failed to reach AI assistant." },
    ]);
     setIsTyping(false);
  }
};


  useEffect(() => {
    if (endOfMessagesRef.current) {
      endOfMessagesRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={toggleChat}
        // className="fixed bottom-5 right-5 z-50 p-4 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-full shadow-2xl hover:scale-110 transition-all duration-300 border-2 border-white animate-pulse"
        className="fixed bottom-5 right-5 z-50 p-4 
             bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 
             bg-[length:200%] bg-[position:0%_50%] 
             animate-gradient-x
             rounded-full shadow-2xl hover:scale-110 
             transition-all duration-300 border-2 border-white"
      >
        {isOpen ? (
          <FiX size={24} className="text-white" />
        ) : (
          // <FiMessageSquare size={24} className="text-white" />
          <img src={bot} className="w-8 h-8" alt="Bot avatar"/>
        )}
      </button>

      {/* Chat Window */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ type: "spring", stiffness: 200 }}
          className="fixed bottom-24 right-5 w-80 bg-white/80 backdrop-blur-md rounded-xl shadow-2xl border z-50 flex flex-col"
        >
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-2 rounded-t-xl font-semibold text-center">
            🤖 WIT – Personal AI
          </div>

          <div className="p-4 h-64 overflow-y-auto text-sm space-y-3 flex flex-col">
            {messages.map((msg, idx) => (
              <div
                key={idx}
                className={`p-2 rounded-lg max-w-[80%] ${
                  msg.sender === "user"
                    ? "bg-blue-100 self-end text-right"
                    : "bg-purple-100 self-start text-left"
                }`}
              >
                {msg.text}
              </div>
            ))}
             {/* 👇 Typing Indicator */}
            {isTyping && (
              <div className="self-start bg-purple-100 text-left p-2 rounded-lg max-w-[60%] flex space-x-1 items-center">
                <div className="flex space-x-1">
                  <span className="w-2 h-2 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: "0s" }}></span>
                  <span className="w-2 h-2 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: "0.15s" }}></span>
                  <span className="w-2 h-2 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: "0.3s" }}></span>
                </div>
              </div>
            )}
            <div ref={endOfMessagesRef} />
          </div>

          <div className="flex border-t p-2 bg-white/70 backdrop-blur">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
              className="flex-1 text-sm px-2 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="Ask something..."
            />
            <button
              onClick={sendMessage}
              className="ml-2 text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 px-3 py-1 rounded-md text-sm transition-all"
            >
              Send
            </button>
          </div>
        </motion.div>
      )}
    </>
  );
};

export default ChatWidget;

